import React from 'react';
import { LockClosedIcon, UserCircleIcon, SpinnerIcon, ChevronLeftIcon } from '../../../components/Icons';
import { CIEN_CUADRAS_BUTTON_BLUE } from '../../../constants';

interface RegisterStepPasswordProps {
  email: string;
  pass: string;
  setPass: (val: string) => void;
  confirmPass: string;
  setConfirmPass: (val: string) => void;
  displayName: string;
  setDisplayName: (val: string) => void;
  onBack: () => void;
  onSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
}

export const RegisterStepPassword: React.FC<RegisterStepPasswordProps> = ({
  email,
  pass,
  setPass,
  confirmPass,
  setConfirmPass,
  displayName,
  setDisplayName,
  onBack,
  onSubmit,
  isLoading,
}) => {
  const canSubmit = pass.trim().length >= 6 && pass === confirmPass;

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div className="flex items-center justify-between pb-1">
        <button
          type="button"
          onClick={onBack}
          disabled={isLoading}
          className="inline-flex items-center text-xs font-semibold text-sky-700 hover:text-sky-900"
        >
          <ChevronLeftIcon className="w-3.5 h-3.5 mr-1" />
          Cambiar correo
        </button>
        <span className="text-xs text-gray-400 font-medium truncate max-w-[180px]">
          {email}
        </span>
      </div>

      <div>
        <label htmlFor="regDisplayName" className="sr-only">Nombre Completo o Inmobiliaria</label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <UserCircleIcon className="h-5 w-5 text-gray-400" />
          </div>
          <input
            id="regDisplayName"
            name="displayName"
            type="text"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            className="appearance-none block w-full px-3 py-2 pl-10 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            placeholder="Nombre Completo (Opcional)"
            disabled={isLoading}
          />
        </div>
      </div>

      <div>
        <label htmlFor="regPassword" className="sr-only">Contraseña</label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <LockClosedIcon className="h-5 w-5 text-gray-400" />
          </div>
          <input
            id="regPassword"
            name="password"
            type="password"
            autoComplete="new-password"
            required
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            className="appearance-none block w-full px-3 py-2 pl-10 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            placeholder="Crear Contraseña (mínimo 6 caracteres)"
            disabled={isLoading}
          />
        </div>
      </div>

      <div>
        <label htmlFor="regConfirmPassword" className="sr-only">Confirmar Contraseña</label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <LockClosedIcon className="h-5 w-5 text-gray-400" />
          </div>
          <input
            id="regConfirmPassword"
            name="confirmPassword"
            type="password"
            autoComplete="new-password"
            required
            value={confirmPass}
            onChange={(e) => setConfirmPass(e.target.value)}
            className="appearance-none block w-full px-3 py-2 pl-10 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            placeholder="Confirmar Contraseña"
            disabled={isLoading}
          />
        </div>
      </div>

      <button
        type="submit"
        disabled={isLoading || !canSubmit}
        className="w-full flex items-center justify-center py-2.5 px-4 rounded-md shadow-sm text-base font-semibold text-white transition-opacity disabled:opacity-60"
        style={{ backgroundColor: CIEN_CUADRAS_BUTTON_BLUE }}
      >
        {isLoading ? <SpinnerIcon className="w-5 h-5 text-white mr-2" /> : null}
        Completar Registro
      </button>
    </form>
  );
};
